import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle } from '@components'
import './DebitCard.scss'
import { DebitCardAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'
import HeaderSection from './../../../common/components/Header/HeaderSection'
import LandingCardBox from './../../../common/components/LandingCardBox'

const DebitCardContainer = styled.div`
  background-color: #fffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`
const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const DebitCard = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    setisLoading(true)
    loadShortDescData()
  }, [])

  const loadData = async function () {
    const reportData = await DebitCardAPI('')
    setdata(reportData.data.data)
  }

  const loadShortDescData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: 'debit_card' })
    setShortDesc(data.data[0])
    setisLoading(false)
    loadData()
  }
  return (
    <div>
      <DebitCardContainer>
        <HeaderSection
          title={shortDesc.title}
          group={t('solusi_keseharian_anda')}
          description={shortDesc.description}
          banner={shortDesc.banner}
          textButton={t('dapatkan_kartu_debit')}
          // showButton={true}
        />
      </DebitCardContainer>
      <InvestorContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="pt-4 px-3 pb-0">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              <div className="row">
                <div className="col-12">
                  <h4>{t('pilih_kartu_debit')}</h4>
                </div>
              </div>
              <div className="row mt-2">
                {data.map((item) => {
                  return (
                    <div className="col-lg-4">
                      <LandingCardBox
                        title={item.title}
                        description={item.description}
                        image={item.imageBannerDesktop}
                        cardImage={item.imageCardDesktop}
                        redirectUrl={'/debit-card/' + item.id}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </InvestorContainer>
      <FooterSection currentPage={t('kartu_debit')} />
    </div>
  )
}

export default DebitCard
